module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "panel-title big-title"
  }, [_vm._v("\n            Mon Compte\n        ")]), _vm._v(" "), (_vm.matchReportList) ? _c('div', {
    staticClass: "panel-content"
  }, [_c('div', {
    staticClass: "row columns"
  }, [_c('ul', {
    staticClass: "tabs horizontal",
    attrs: {
      "data-tab": ""
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'myMatchs'
      }
    }
  }, [_vm._v("Mes Matchs")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'myInfos'
      }
    }
  }, [_vm._v("Mes Informations")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'myTeams'
      }
    }
  }, [_vm._v("Mes équipes")])], 1)])]), _vm._v(" "), _c('router-view')], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ef2e276"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/my-account/my-account.vue
// module id = 778
// module chunks = 0